const en = {
    title: 'Retention and final deletion',
    description: 'Stored mail remains separate from its remote mailbox and record links.',
    remoteMissing: 'A remote move or deletion marks a location as missing. The stored message remains readable under its existing permissions.',
    unlink: 'Removing a record link or marking a message irrelevant does not erase the stored message.',
    manage: 'Review retention',
    loadFailed: 'Retention controls are unavailable. Current reading and administration rights are required for every copy.',
    reason: 'Reason for this decision',
    reasonInvalid: 'Enter a reason of 3 to 1,000 characters.',
    policies: 'Mailbox retention rules',
    enablePurge: 'Allow reviewed final deletion',
    ageDays: 'Minimum age in days',
    ageInvalid: 'Enter a whole number from 0 to {{max}} days.',
    policySave: 'Save mailbox rule',
    ageInfo: 'Disabled means keep indefinitely. The chosen age is an internal rule, not a universal legal retention period.',
    hold: 'Message retention hold',
    held: 'Keep this message on hold',
    retainThrough: 'Also retain through this date',
    holdSave: 'Save hold',
    review: 'Prepare deletion preview',
    reviewTitle: 'Review final deletion',
    reviewText: 'This affects every stored copy, decoded file, record link and processing state listed in this preview. Remote mailbox contents are not changed.',
    sources: 'Stored copies',
    files: 'Files',
    workItems: 'Processing items',
    bytes: 'Stored bytes',
    links: 'Record links',
    eligible: 'The current checks allow a final deletion preview.',
    confirm: 'Delete reviewed message permanently',
    confirmed: 'I have reviewed the scope and understand that ERP deletion cannot be undone.',
    cancel: 'Cancel preview',
    saveFirst: 'Save or discard changed retention settings before preparing a preview.',
    stale: 'The preview is stale or the current permissions changed. Refresh and review again; your reason is retained.',
    failed: 'The operation could not be completed. Your inputs are retained. Retry a pending deletion with the same preview.',
    refresh: 'Refresh current checks',
    purged: 'The message has been removed from the ERP.',
    pendingCleanup: 'Private file erasure is pending and will be retried automatically. The files are no longer available through the ERP.',
    denied: 'The current permissions do not allow this operation.',
    previewUnavailable: 'A deletion preview is currently unavailable.',
    previewStale: 'The reviewed scope changed or expired. Prepare a new preview.',
    immutableProof: 'The stored deletion proof cannot be changed.',
    featureDisabled: 'Mail processing is disabled.',
    maintenance: 'The operation is paused during maintenance.',
    sourcePurged: 'This source was explicitly erased and will not be imported again.',
    NATIVE_EVIDENCE: 'Business sending evidence is retained and cannot be erased here.',
    BUSINESS_RELEASE: 'A business copy is still released. Review its release separately; deletion never removes a release automatically.',
    LINKED_RECORD: 'An active or ambiguous record relationship still requires retention. Unlinking is a separate decision.',
    HOLD: 'An explicit hold or retention date prevents deletion.',
    POLICY_DISABLED: 'At least one mailbox has not explicitly enabled final deletion.',
    MINIMUM_AGE: 'A mailbox minimum age has not yet been reached.',
    EXTERNAL_REFERENCE: 'Another protected record depends on this message or its files.',
    SOURCE_LIMIT: 'This message requires a separate review because its stored scope exceeds the preview limit.',
};
export const mailLifecycleLabels = {
    en,
    de: {
        title: 'Aufbewahrung und endgültiges Löschen',
        description: 'Gespeicherte E-Mails sind vom entfernten Postfach und ihren Aktenverknüpfungen getrennt.',
        remoteMissing: 'Ein Verschieben oder Löschen im Postfach markiert einen Ablageort als nicht mehr vorhanden. Die gespeicherte Nachricht bleibt mit den bisherigen Rechten lesbar.',
        unlink: 'Das Entfernen einer Aktenverknüpfung oder die Kennzeichnung als irrelevant löscht die gespeicherte Nachricht nicht.',
        manage: 'Aufbewahrung prüfen',
        loadFailed: 'Die Aufbewahrungsverwaltung ist nicht verfügbar. Für jede Kopie sind aktuelle Lese- und Verwaltungsrechte erforderlich.',
        reason: 'Grund für diese Entscheidung',
        reasonInvalid: 'Geben Sie einen Grund mit 3 bis 1.000 Zeichen ein.',
        policies: 'Aufbewahrungsregeln der Postfächer',
        enablePurge: 'Geprüftes endgültiges Löschen zulassen',
        ageDays: 'Mindestalter in Tagen',
        ageInvalid: 'Geben Sie eine ganze Zahl von 0 bis {{max}} Tagen ein.',
        policySave: 'Postfachregel speichern',
        ageInfo: 'Deaktiviert bedeutet unbegrenzt aufbewahren. Das gewählte Alter ist eine interne Regel und keine allgemeine gesetzliche Aufbewahrungsfrist.',
        hold: 'Aufbewahrungssperre der Nachricht',
        held: 'Diese Nachricht gesperrt aufbewahren',
        retainThrough: 'Zusätzlich bis einschließlich dieses Datums aufbewahren',
        holdSave: 'Sperre speichern',
        review: 'Löschvorschau vorbereiten',
        reviewTitle: 'Endgültige Löschung prüfen',
        reviewText: 'Betroffen sind alle in dieser Vorschau aufgeführten gespeicherten Kopien, entpackten Dateien, Aktenverknüpfungen und Bearbeitungsstände. Inhalte im entfernten Postfach werden nicht geändert.',
        sources: 'Gespeicherte Kopien',
        files: 'Dateien',
        workItems: 'Bearbeitungseinträge',
        bytes: 'Gespeicherte Bytes',
        links: 'Aktenverknüpfungen',
        eligible: 'Die aktuellen Prüfungen erlauben eine Vorschau zur endgültigen Löschung.',
        confirm: 'Geprüfte Nachricht endgültig löschen',
        confirmed: 'Ich habe den Umfang geprüft und verstanden, dass die ERP-Löschung nicht rückgängig gemacht werden kann.',
        cancel: 'Vorschau abbrechen',
        saveFirst: 'Speichern oder verwerfen Sie geänderte Aufbewahrungsregeln vor der Löschvorschau.',
        stale: 'Die Vorschau ist veraltet oder die Rechte haben sich geändert. Laden Sie den Stand neu und prüfen Sie erneut; Ihr Grund bleibt erhalten.',
        failed: 'Der Vorgang konnte nicht abgeschlossen werden. Ihre Eingaben bleiben erhalten. Wiederholen Sie eine ausstehende Löschung mit derselben Vorschau.',
        refresh: 'Aktuelle Prüfungen neu laden',
        purged: 'Die Nachricht wurde aus dem ERP entfernt.',
        pendingCleanup: 'Das Löschen der privaten Dateien steht noch aus und wird automatisch erneut versucht. Über das ERP sind die Dateien nicht mehr verfügbar.',
        denied: 'Die aktuellen Rechte erlauben diesen Vorgang nicht.',
        previewUnavailable: 'Eine Löschvorschau ist derzeit nicht verfügbar.',
        previewStale: 'Der geprüfte Umfang wurde geändert oder ist abgelaufen. Erstellen Sie eine neue Vorschau.',
        immutableProof: 'Der gespeicherte Löschnachweis darf nicht geändert werden.',
        featureDisabled: 'Die E-Mail-Verarbeitung ist deaktiviert.',
        maintenance: 'Der Vorgang pausiert während der Wartung.',
        sourcePurged: 'Diese Quelle wurde ausdrücklich gelöscht und wird nicht erneut importiert.',
        NATIVE_EVIDENCE: 'Geschäftliche Versandnachweise werden aufbewahrt und können hier nicht gelöscht werden.',
        BUSINESS_RELEASE: 'Eine geschäftliche Kopie ist noch freigegeben. Prüfen Sie die Freigabe getrennt; eine Löschung hebt sie niemals automatisch auf.',
        LINKED_RECORD: 'Eine aktive oder mehrdeutige Aktenbeziehung erfordert weiterhin Aufbewahrung. Das Aufheben der Verknüpfung ist eine eigene Entscheidung.',
        HOLD: 'Eine ausdrückliche Sperre oder ein Aufbewahrungsdatum verhindert die Löschung.',
        POLICY_DISABLED: 'Mindestens ein Postfach hat das endgültige Löschen nicht ausdrücklich aktiviert.',
        MINIMUM_AGE: 'Das Mindestalter eines Postfachs wurde noch nicht erreicht.',
        EXTERNAL_REFERENCE: 'Ein anderer geschützter Datensatz benötigt diese Nachricht oder ihre Dateien.',
        SOURCE_LIMIT: 'Der gespeicherte Umfang dieser Nachricht überschreitet die Vorschaugrenze und benötigt eine gesonderte Prüfung.',
    },
    fr: {
        title: 'Conservation et suppression définitive',
        description: 'Les courriels conservés sont distincts de la boîte distante et des liens aux dossiers.',
        remoteMissing: 'Un déplacement ou une suppression distante marque un emplacement comme absent. Le message conservé reste lisible avec les droits existants.',
        unlink: 'Retirer un lien de dossier ou déclarer un message sans pertinence ne supprime pas le message conservé.',
        manage: 'Examiner la conservation',
        loadFailed: 'Les contrôles de conservation sont indisponibles. Des droits actuels de lecture et de gestion sont nécessaires pour chaque copie.',
        reason: 'Motif de cette décision',
        reasonInvalid: 'Saisissez un motif de 3 à 1 000 caractères.',
        policies: 'Règles de conservation des boîtes',
        enablePurge: 'Autoriser la suppression définitive après examen',
        ageDays: 'Âge minimal en jours',
        ageInvalid: 'Saisissez un nombre entier de 0 à {{max}} jours.',
        policySave: 'Enregistrer la règle de boîte',
        ageInfo: 'Désactivé signifie conserver indéfiniment. L’âge choisi est une règle interne, pas une durée légale universelle.',
        hold: 'Blocage de conservation du message',
        held: 'Maintenir ce message sous blocage',
        retainThrough: 'Conserver également jusqu’à cette date incluse',
        holdSave: 'Enregistrer le blocage',
        review: 'Préparer l’aperçu de suppression',
        reviewTitle: 'Examiner la suppression définitive',
        reviewText: 'Toutes les copies conservées, fichiers décodés, liens aux dossiers et états de traitement indiqués dans cet aperçu sont concernés. La boîte distante reste inchangée.',
        sources: 'Copies conservées',
        files: 'Fichiers',
        workItems: 'Éléments de traitement',
        bytes: 'Octets conservés',
        links: 'Liens aux dossiers',
        eligible: 'Les vérifications actuelles autorisent un aperçu de suppression définitive.',
        confirm: 'Supprimer définitivement le message examiné',
        confirmed: 'J’ai examiné le périmètre et compris que la suppression dans l’ERP est irréversible.',
        cancel: 'Annuler l’aperçu',
        saveFirst: 'Enregistrez ou abandonnez les modifications de conservation avant de préparer un aperçu.',
        stale: 'L’aperçu est périmé ou les droits ont changé. Actualisez puis examinez à nouveau ; votre motif est conservé.',
        failed: 'L’opération n’a pas abouti. Vos saisies sont conservées. Réessayez une suppression en attente avec le même aperçu.',
        refresh: 'Actualiser les vérifications',
        purged: 'Le message a été retiré de l’ERP.',
        pendingCleanup: 'L’effacement des fichiers privés est en attente et sera automatiquement réessayé. Ils ne sont plus accessibles dans l’ERP.',
        denied: 'Les droits actuels ne permettent pas cette opération.',
        previewUnavailable: 'Un aperçu de suppression est actuellement indisponible.',
        previewStale: 'Le périmètre examiné a changé ou expiré. Préparez un nouvel aperçu.',
        immutableProof: 'La preuve de suppression conservée ne peut pas être modifiée.',
        featureDisabled: 'Le traitement des courriels est désactivé.',
        maintenance: 'L’opération est suspendue pendant la maintenance.',
        sourcePurged: 'Cette source a été explicitement effacée et ne sera pas réimportée.',
        NATIVE_EVIDENCE: 'Les preuves d’envoi professionnel sont conservées et ne peuvent pas être effacées ici.',
        BUSINESS_RELEASE: 'Une copie professionnelle reste publiée. Examinez cette publication séparément ; la suppression ne l’annule jamais automatiquement.',
        LINKED_RECORD: 'Un lien de dossier actif ou ambigu impose encore la conservation. Retirer ce lien est une décision distincte.',
        HOLD: 'Un blocage explicite ou une date de conservation empêche la suppression.',
        POLICY_DISABLED: 'Au moins une boîte n’a pas explicitement activé la suppression définitive.',
        MINIMUM_AGE: 'L’âge minimal défini pour une boîte n’est pas encore atteint.',
        EXTERNAL_REFERENCE: 'Un autre enregistrement protégé dépend de ce message ou de ses fichiers.',
        SOURCE_LIMIT: 'Le périmètre conservé dépasse la limite de l’aperçu et nécessite un examen séparé.',
    },
    es: {
        title: 'Conservación y eliminación definitiva',
        description: 'Los correos almacenados se mantienen separados del buzón remoto y de sus vínculos con expedientes.',
        remoteMissing: 'Mover o eliminar en el buzón remoto marca una ubicación como ausente. El mensaje almacenado sigue siendo legible con sus permisos existentes.',
        unlink: 'Quitar un vínculo con un expediente o marcar un mensaje como irrelevante no elimina el mensaje almacenado.',
        manage: 'Revisar conservación',
        loadFailed: 'Los controles de conservación no están disponibles. Se necesitan permisos actuales de lectura y administración para cada copia.',
        reason: 'Motivo de esta decisión',
        reasonInvalid: 'Introduzca un motivo de entre 3 y 1.000 caracteres.',
        policies: 'Reglas de conservación de los buzones',
        enablePurge: 'Permitir la eliminación definitiva revisada',
        ageDays: 'Antigüedad mínima en días',
        ageInvalid: 'Introduzca un número entero de 0 a {{max}} días.',
        policySave: 'Guardar regla del buzón',
        ageInfo: 'Desactivado significa conservar indefinidamente. La antigüedad elegida es una regla interna, no un plazo legal universal.',
        hold: 'Bloqueo de conservación del mensaje',
        held: 'Mantener este mensaje bloqueado',
        retainThrough: 'Conservar también hasta esta fecha inclusive',
        holdSave: 'Guardar bloqueo',
        review: 'Preparar vista previa de eliminación',
        reviewTitle: 'Revisar eliminación definitiva',
        reviewText: 'Afecta a todas las copias almacenadas, archivos descodificados, vínculos con expedientes y estados de tramitación indicados. El contenido del buzón remoto no cambia.',
        sources: 'Copias almacenadas',
        files: 'Archivos',
        workItems: 'Elementos de tramitación',
        bytes: 'Bytes almacenados',
        links: 'Vínculos con expedientes',
        eligible: 'Las comprobaciones actuales permiten una vista previa de eliminación definitiva.',
        confirm: 'Eliminar definitivamente el mensaje revisado',
        confirmed: 'He revisado el alcance y entiendo que la eliminación en el ERP no se puede deshacer.',
        cancel: 'Cancelar vista previa',
        saveFirst: 'Guarde o descarte los cambios de conservación antes de preparar la vista previa.',
        stale: 'La vista previa está obsoleta o los permisos han cambiado. Actualice y revise de nuevo; se conserva el motivo.',
        failed: 'No se pudo completar la operación. Se conservan sus datos. Reintente una eliminación pendiente con la misma vista previa.',
        refresh: 'Actualizar comprobaciones',
        purged: 'El mensaje se ha eliminado del ERP.',
        pendingCleanup: 'El borrado de archivos privados está pendiente y se reintentará automáticamente. Los archivos ya no están disponibles a través del ERP.',
        denied: 'Los permisos actuales no permiten esta operación.',
        previewUnavailable: 'La vista previa de eliminación no está disponible actualmente.',
        previewStale: 'El alcance revisado ha cambiado o ha caducado. Prepare una nueva vista previa.',
        immutableProof: 'No se puede modificar la prueba de eliminación almacenada.',
        featureDisabled: 'El procesamiento del correo está desactivado.',
        maintenance: 'La operación está pausada durante el mantenimiento.',
        sourcePurged: 'Esta fuente se borró explícitamente y no se volverá a importar.',
        NATIVE_EVIDENCE: 'Las pruebas de envío empresarial se conservan y no se pueden borrar aquí.',
        BUSINESS_RELEASE: 'Una copia empresarial sigue compartida. Revise esa autorización por separado; la eliminación nunca la retira automáticamente.',
        LINKED_RECORD: 'Un vínculo activo o ambiguo con un expediente sigue exigiendo conservación. Retirarlo es una decisión independiente.',
        HOLD: 'Un bloqueo explícito o una fecha de conservación impide eliminar.',
        POLICY_DISABLED: 'Al menos un buzón no ha activado explícitamente la eliminación definitiva.',
        MINIMUM_AGE: 'Todavía no se ha alcanzado la antigüedad mínima de un buzón.',
        EXTERNAL_REFERENCE: 'Otro registro protegido depende de este mensaje o de sus archivos.',
        SOURCE_LIMIT: 'El alcance almacenado supera el límite de la vista previa y requiere una revisión independiente.',
    },
    tr: {
        title: 'Saklama ve kalıcı silme',
        description: 'Saklanan e-postalar uzak posta kutusundan ve dosya bağlantılarından ayrıdır.',
        remoteMissing: 'Uzak posta kutusunda taşıma veya silme, bir konumu artık mevcut değil olarak işaretler. Saklanan ileti mevcut izinlerle okunabilir.',
        unlink: 'Bir dosya bağlantısını kaldırmak veya iletiyi ilgisiz işaretlemek saklanan iletiyi silmez.',
        manage: 'Saklamayı incele',
        loadFailed: 'Saklama denetimleri kullanılamıyor. Her kopya için güncel okuma ve yönetim izinleri gerekir.',
        reason: 'Bu kararın gerekçesi',
        reasonInvalid: '3 ile 1.000 karakter arasında bir gerekçe girin.',
        policies: 'Posta kutusu saklama kuralları',
        enablePurge: 'İncelenen kalıcı silmeye izin ver',
        ageDays: 'Gün olarak asgari yaş',
        ageInvalid: '0 ile {{max}} gün arasında bir tam sayı girin.',
        policySave: 'Posta kutusu kuralını kaydet',
        ageInfo: 'Kapalı olduğunda süresiz saklanır. Seçilen süre kurum içi bir kuraldır; evrensel bir yasal saklama süresi değildir.',
        hold: 'İleti saklama kilidi',
        held: 'Bu iletiyi saklama kilidinde tut',
        retainThrough: 'Bu tarih dahil saklamaya devam et',
        holdSave: 'Kilidi kaydet',
        review: 'Silme önizlemesini hazırla',
        reviewTitle: 'Kalıcı silmeyi incele',
        reviewText: 'Bu önizlemede listelenen tüm saklanmış kopyalar, çözümlenmiş dosyalar, dosya bağlantıları ve işlem durumları etkilenir. Uzak posta kutusu içeriği değiştirilmez.',
        sources: 'Saklanan kopyalar',
        files: 'Dosyalar',
        workItems: 'İşlem kayıtları',
        bytes: 'Saklanan baytlar',
        links: 'Dosya bağlantıları',
        eligible: 'Güncel denetimler kalıcı silme önizlemesine izin veriyor.',
        confirm: 'İncelenen iletiyi kalıcı sil',
        confirmed: 'Kapsamı inceledim ve ERP silme işleminin geri alınamayacağını anladım.',
        cancel: 'Önizlemeyi iptal et',
        saveFirst: 'Önizleme hazırlamadan önce değişen saklama ayarlarını kaydedin veya vazgeçin.',
        stale: 'Önizleme eskidi veya izinler değişti. Yenileyip tekrar inceleyin; gerekçeniz korunur.',
        failed: 'İşlem tamamlanamadı. Girdileriniz korunur. Bekleyen silmeyi aynı önizlemeyle yeniden deneyin.',
        refresh: 'Güncel denetimleri yenile',
        purged: 'İleti ERP’den kaldırıldı.',
        pendingCleanup: 'Özel dosyaların silinmesi bekliyor ve otomatik olarak yeniden denenecek. Dosyalara artık ERP üzerinden erişilemez.',
        denied: 'Güncel izinler bu işleme izin vermiyor.',
        previewUnavailable: 'Silme önizlemesi şu anda kullanılamıyor.',
        previewStale: 'İncelenen kapsam değişti veya süresi doldu. Yeni bir önizleme hazırlayın.',
        immutableProof: 'Saklanan silme kanıtı değiştirilemez.',
        featureDisabled: 'E-posta işleme devre dışı.',
        maintenance: 'Bakım sırasında işlem duraklatılır.',
        sourcePurged: 'Bu kaynak açıkça silindi ve yeniden içe aktarılmayacak.',
        NATIVE_EVIDENCE: 'Ticari gönderim kanıtları saklanır ve buradan silinemez.',
        BUSINESS_RELEASE: 'Ticari bir kopya hâlâ paylaşılmış durumda. Paylaşımı ayrıca inceleyin; silme bunu otomatik kaldırmaz.',
        LINKED_RECORD: 'Etkin veya belirsiz bir dosya ilişkisi saklamayı gerektiriyor. Bağlantıyı kaldırmak ayrı bir karardır.',
        HOLD: 'Açık bir kilit veya saklama tarihi silmeyi engelliyor.',
        POLICY_DISABLED: 'En az bir posta kutusu kalıcı silmeyi açıkça etkinleştirmedi.',
        MINIMUM_AGE: 'Bir posta kutusunun asgari yaşına henüz ulaşılmadı.',
        EXTERNAL_REFERENCE: 'Başka bir korunan kayıt bu iletiye veya dosyalarına bağlı.',
        SOURCE_LIMIT: 'Saklanan kapsam önizleme sınırını aşıyor ve ayrı inceleme gerektiriyor.',
    },
};
//# sourceMappingURL=mail-lifecycle-labels.js.map